<template>
    <h1>Mentor Board</h1>
</template>
<script>
export default {
    name : "mentorBoardView"
};
</script>
